import Vue from 'vue'
import 'swiper/css/swiper.min.css'

/**
 *    Главная страница читального зала
 */
// import main from './pages/articles/index.vue';
// Vue.component('articles_main', main);

/**
 *    Старая Главная страница читального зала
 */
import main from './pages/articles/indexOld.vue';
Vue.component('articles_main', main);

/**
 * Страница статьи
 */
import single from './pages/articles/single.vue';
Vue.component('single', single);

/**
 * Страница одного кейса
 */
import SingleCase from './pages/static/cases/SingleCase'
Vue.component('single_case', SingleCase)
